import { log, logAPI } from "./andyliticsApi";
import { UserInitiatedLogoutMessage } from "../constants/textConstants";
import * as tools from "../helpers/Tools";

const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : ''; // window is undefined during pre-render
const portalApiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.portalAPIURL : ''; // window is undefined during pre-render

/**
 * changeUserName
 * 
 * @param {string} token  = current user token
 * @param {string} OldUserName = HealthSource UserName
 * @param {string} NewUserName = new UserName
 * @returns {Promise} "OK" or not
 */
export const changeUserName = (token, OldUserName, NewUserName) => {
    const url = encodeURI( tools.buildUrl( apiBaseUrl, 'api/v2/account/ChangeUserName'));
    const start = new Date();
    const data = { NewUserName: NewUserName, OldUserName: OldUserName };
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Settings.ChangeUserName", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.ChangeUserName.Failure", start, url, err); return Promise.reject(err); });
};

/**
 * changePassword
 * 
 * @param {string} token  = current user token
 * @param {string} UserName = HealthSource UserName
 * @param {string} OldPassword = current user's current password
 * @param {string} NewPassword = current user's new password
 * @param {string} ConfirmPassword = current user's current password
 * @returns {Promise} "OK" or not
 */
export const changePassword = (token, UserName, OldPassword, NewPassword, ConfirmPassword) => {
    const url = encodeURI( tools.buildUrl( apiBaseUrl, 'api/v2/account/ChangePassword'));
    const start = new Date();
    const data = { Email: UserName, OldPassword: OldPassword, NewPassword: NewPassword, ConfirmPassword: ConfirmPassword };
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Settings.ChangePassword", start, url);
        //debugger;
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.ChangePassword.Failure", start, url, err); return Promise.reject(err); });
};



/**
 * forgotPassword
 * 
 * @param {string} token  = current user token
 * @param {string} UserName = HealthSource UserName
 * @param {string} DOB = current user's Date of birth
 * @param {string} ZipCode = current user's Zipcode
 * @returns {Promise} ResultStructure
 */
export const forgotPassword = (token, UserName, DOB, ZipCode) => {
    //const url = encodeURI(`${apiBaseUrl}api/v2/account/ForgotPassword`);
    const url = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/ForgotPassword`));
    const start = new Date();
    const data = { UserName: UserName, DOB: DOB, ZipCode: ZipCode };
    //debugger;
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Settings.ForgotPassword", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.ForgotPassword.Failure", start, url, err); return Promise.reject(err); });
};

export const resetPassword = (token, userId, password) => {
    //const url = encodeURI(`${apiBaseUrl}api/v2/account/ResetPassword`);
    const url = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/ResetPassword`));
    const start = new Date();
    const data = { token, userId, password, confirmPassword: password };
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Settings.ResetPassword", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.ResetPassword.Failure", start, url, err); return Promise.reject(err); });
};

/**
 * forgotUserName
 * 
 * @param {string} token  = current user token
 * @param {string} Email = Email
 * @param {string} DOB = current user's Date of birth
 * @param {string} FirstName = current user's Zipcode
 * @param {string} LastName = current user's Zipcode
 * @param {string} ZipCode = current user's Zipcode
 * @param {boolean} SendEmail = strange parameter, we always wanna send the email
 * @returns {Promise} ResultStructure
 */
export const forgotUserName = (token, Email, DOB, FirstName, LastName, ZipCode, SendEmail) => {
    //const url = encodeURI(`${apiBaseUrl}api/v2/account/ForgotUserName`);
    const url = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/ForgotUserName`));
    const start = new Date();
    const data = { Email, DOB, ZipCode, FirstName, LastName, SendEmail };
    //debugger;
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Settings.ForgotUsername", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.ForgotUsername.Failure", start, url, err); return Promise.reject(err); });
};

/**
 * changeEmail
 * 
 * @param {string} token  = current user token
 * @param {string} Username = HealthSource UserName
 * @param {string} NewEmail = new Email
 * @param {string} ConfirmEmail = new Email
 * @returns {Promise} "OK" or not
 */
export const changeEmail = (token, Username, NewEmail, ConfirmEmail) => {
    const url = encodeURI(`${apiBaseUrl}api/v2/account/ChangeEmail`);
    const start = new Date();
    const data = { Username, NewEmail, ConfirmEmail };
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Settings.ChangeEmail", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.ChangeEmail.Failure", start, url, err); return Promise.reject(err); });
};






/**
 * linkEmployeeAccount
 * 
 * @param {string} token  = current user token
 * @param {string} CorporateId = LAN ID
 * @param {string} CorporatePassword = LAN Password
 * @param {boolean} HasEmployeeLogin = Has Employee Login ... think this should always be true   lol  :)
 * @param {string} UserName = current user's UserName
 * @returns {Promise} ResultStructure
 */
export const linkEmployeeAccount = (token, CorporateId, CorporatePassword, HasEmployeeLogin, UserName) => {
    try {
        //debugger;
        const url = encodeURI(tools.buildUrl( portalApiBaseUrl,  `/LinkEmployee`));
        //debugger;
        const start = new Date();
        const data = { CorporateId: CorporateId, CorporatePassword: CorporatePassword, HasEmployeeLogin: HasEmployeeLogin, UserName: UserName };
        return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
            logAPI("MBHWeb.Api.Account.Employee.Link", start, url);
            return response;
        }).catch(err => { logAPI("MBHWeb.Api.Account.Employee.Link.Failure", start, url, err); return Promise.reject(err); });
    }
    catch (E) {
        //debugger;
        throw E;
    }
};

/**
 * unlinkEmployeeAccount
 * 
 * @param {string} token  = current user token
 * @param {boolean} HasEmployeeLogin = Has Employee Login ... think this should always be true   lol  :)
 * @param {string} UserName = current user's UserName
 * @returns {Promise} ResultStructure
 */
export const unlinkEmployeeAccount = (token, HasEmployeeLogin, UserName) => {
    try {
        //debugger;
        const url = encodeURI(tools.buildUrl( portalApiBaseUrl, `/UnlinkEmployee`));
        const start = new Date();
        const data = { HasEmployeeLogin: HasEmployeeLogin, UserName: UserName };
        //debugger;
        return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
            logAPI("MBHWeb.Api.Account.Employee.Unlink", start, url);
            return response;
        }).catch(err => { logAPI("MBHWeb.Api.Account.Employee.Unlink.Failure", start, url, err); return Promise.reject(err); });

    }
    catch (E) {
        //debugger;
        throw E;
    }

};

/**
 * linkMyChartAccount
 * 
 * @param {string} token  = current user token
 * @param {string} MemberId = MyChart ID
 * @param {string} Password = MyChart Password
 * @param {boolean} HasMyChartLogin = Has MyChart Login ... think this should always be true   lol  :)
 * @param {string} UserName = current user's UserName
 * @returns {Promise} ResultStructure
 */
export const linkMyChartAccount = (token, MemberId, Password, HasMyChartLogin, UserName) => {
    try {
        //debugger;
        const url = encodeURI( tools.buildUrl( portalApiBaseUrl, `/LinkMyChart`));
        const data = {
            MemberId: MemberId,
            Password: Password,
            HasMyChartLogin: HasMyChartLogin ? HasMyChartLogin : true, //Default to true as per above comments.
            UserName: UserName
        };
        //debugger;
        const start = new Date();
        return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
            logAPI("MBHWeb.Api.Account.MyChart.Link", start, url);
            return response;
        }).catch(err => { logAPI("MBHWeb.Api.Account.MyChart.Link.Failure", start, url, err); return Promise.reject(err); });
    }
    catch (E) {
        //debugger;
        throw E;
    }
};

/**
 * unlinkMyChartAccount
 * 
 * @param {string} token  = current user token
 * @param {boolean} HasMyChartLogin = Has MyChart Login ... think this should always be true   lol  :)
 * @param {string} UserName = current user's UserName
 * @returns {Promise} ResultStructure
 */
export const unlinkMyChartAccount = (token, HasMyChartLogin, UserName) => {
    try {
        //debugger;
        const url = encodeURI( tools.buildUrl( portalApiBaseUrl, `/UnlinkMyChart`));
        const start = new Date();
        const data = { HasMyChartLogin: HasMyChartLogin, UserName: UserName };
        //debugger;
        return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
            logAPI("MBHWeb.Api.Account.MyChart.Unlink", start, url);
            return response;
        }).catch(err => { logAPI("MBHWeb.Api.Account.MyChart.Unlink.Failure", start, url, err); return Promise.reject(err); });

    }
    catch (E) {
        //debugger;
        throw E;
    }

};

/**
* getUserPhoneNumber
* 
* @param {string} token  = current user token
* @param {string} UserName = UserName 
* @returns {Promise} ResultStructure
 */
export const getUserPhoneNumber = (token, UserName) => {
    const url = `${apiBaseUrl}v1/Profile/GetUserPhone?phoneType=mobile&userName=${encodeURIComponent(UserName)}`;
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Settings.GetUserPhone", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Settings.GetUserPhone.Failure", start, url, err); return Promise.reject(err); });
};

/**
* addOrUpdateUserPhoneNumber
* 
* @param {string} token  = current user token
* @param {string} UserName = UserName 
* @param {string} areaCode = area code
* @param {string} phoneNumber = phone number
* @param {string} userId = userId 
* @returns {Promise} unknown
 * */
export const addOrUpdateUserPhoneNumber = (token, UserName, areaCode, phoneNumber, userId, newUser) => {
    let url = "";
    let methodType = "";
    let methodName = "";
    var phone = { PhoneType: 'mobile', CountryCode: '1', AreaCode: areaCode, PhoneNumber: phoneNumber, UserId: userId }; //getUpdatedPhone();   
    if (!newUser) {
        url = `${apiBaseUrl}v1/Profile/UpdateUserPhone?userName=${encodeURIComponent(UserName)}`;
        methodType = "put";
        methodName = "Settings.UpdateUserPhone";
    }
    else {
        url = `${apiBaseUrl}v1/Profile/CreateUserPhone?userName=${encodeURIComponent(UserName)}`;
        methodType = "post";
        methodName = "Settings.UpdateUserPhone";
    }

    const params = {
        method: methodType,
        body: JSON.stringify(phone),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        }
    };

    const start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api." + methodName, start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api." + { methodName } + ".Failure", start, url, err); return Promise.reject(err); });
};

export const getNotificationPreference = (token, userName) => {
    const url = `${apiBaseUrl}v2/HealthSource/Preferences/GetUserNotificationPreferences?userName=${encodeURIComponent(userName)}`;
    const start = new Date();
    const activityCode = "MBHWeb.Api.HealthSource.GetUserNotificationPreference";
    
    return fetch2(url, token).then(response => {
        logAPI(activityCode, start, url);     
        return response;
    }).catch(error => {
        logAPI(activityCode + ".Failure", start, url, { error: "We currently are unable to change your preference." });
        throw error;
    });
};

export const saveNotificationPreference = (token, userName, useEmail, useSms, usePush, eventName) => {
    const url = encodeURI(`${apiBaseUrl}v2/HealthSource/Preferences/SaveUserNotificationPreference`);
    const start = new Date();
    const data = { eventName: eventName, userName, useEmail, useSms, usePush };
    let activityCode = "";
    if (eventName === "PharmacyNotification")
        activityCode = "MBHWeb.Api.Rx.Notifications.UpdateCommunicationPreference";
    else if (eventName === "XealthNotification")
        activityCode = "MBHWeb.Api.CareCoach.Notifications.UpdateCommunicationPreference";
    else if (eventName === "GeneralNotification")
        activityCode = "MBHWeb.Api.General.Notifications.UpdateCommunicationPreference";

    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI(activityCode, start, url, { eventName: eventName });
        return 'success';
    }).catch(error => {
        const errorMessage = eventName ? "We're sorry, we currently are unable to save your" + eventName + "preference." : "We're sorry, we currently are unable to save your preference.";
        logAPI(activityCode + ".Failure", start, url, { error: errorMessage });
        throw (error ? error : errorMessage);
    });
};

/**
* getUserAddresses
* 
* @param {string} token  = current user token
* @param {string} UserName = UserName 
* @returns {Promise} ResultStructure
 */
export const getUserAddresses = (token, UserName) => {
    if (typeof UserName === "undefined" || UserName === null || UserName === "") {
        //debugger;
        return [];  // should be checking these elsewhere, but oh well.
    }
    const url = `${apiBaseUrl}v1/Profile/GetUserAddresses?userName=${encodeURIComponent(UserName)}`;
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Account.GetUserAddress", start, url);
        return response;
    }).catch((err) => {
        //debugger;
        logAPI("MBHWeb.Api.Account.GetUserAddress.Failure", start, url, err);
        return [];
    });
};


/**
 * getHideTutorial
 * 
 * @param {string} token  = current user token
 * @returns {Promise} ResultStructure
 */
export const getHideTutorial = (token) => {
        const fullUrl = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/GetHideTutorial`));
        const params = {
            headers: {
                "accept": "application/json",
                "authorization": "bearer " + token
            },
            method: "GET"
        };
        var start = new Date();
    return fetchWithCreds(fullUrl, params).then(response => {
        //logAPI("MBHWeb.NotSureWeShouldLogThis", start, fullUrl);
        try {
            return response.json();
        }
        catch (E) {
            return [{ isSuccessful: false }];
        }
        }).catch(err => {
            return [{ isSuccessful: false }];
        });
};



/**
* setHideTutorial
* 
* @param {string} token  = current user token
* @returns {Promise} ResultStructure
*/
export const setHideTutorial = (token) => {

    const fullUrl = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/SetHideTutorial`));
    const params = {
        headers: {
            "accept": "application/json",
            "authorization": "bearer " + token
        },
        method: "POST"
    };
    var start = new Date();
    return fetchWithCreds(fullUrl, params).then(response => {
        //logAPI("MBHWeb.NotSureWeShouldLogThis", start, fullUrl);
        try {
            return response.json();
        }
        catch (E) {
            return [{ isSuccessful: false }];
        }
    }).catch(err => {
        return { isSuccessful: false };
    });
};

/**
 * getUserPreferences
 * 
 * @param {string} token  = current user token
 * @returns {Promise} ResultStructure
 */
export const getUserPreferences = (token, key) => {
    const fullUrl = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/GetUserPreferences/${key}`));
    const params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    var start = new Date();
    const activityCode = `MBHWeb.Api.Account.GetUserPreferences.${key}.Get`;
    return fetchWithCreds(fullUrl, params).then(response => {       
        try {
            logAPI(activityCode, start, fullUrl);
            return response.json();
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, fullUrl, E);
            return [{ isSuccessful: false }];
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, fullUrl, err);
        return [{ isSuccessful: false }];
    });
};


/**
 * getUserPreferences2
 * 
 * @param {string} token  = current user token
 * @returns {Promise} ResultStructure
 */
export const getUserPreferences2 = (token, key) => {
    const fullUrl = encodeURI(tools.buildUrl(apiBaseUrl, `/v2/HealthSource/Preferences/${key}`));
    const params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    var start = new Date();
    const activityCode = `MBHWeb.Api.Account.GetUserPreferences2.${key}.Get`;
    return fetch(fullUrl, params).then(response => {
        try {
            logAPI(activityCode, start, fullUrl);
            return response.json();
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, fullUrl, E);
            return [{ isSuccessful: false }];
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, fullUrl, err);
        return [{ isSuccessful: false }];
    });
};



/**
* resetUserPreferences
* 
* @param {string} token  = current user token
* @returns {Promise} ResultStructure
*/
export const resetUserPreferences = (token, key, value) => {

    const fullUrl = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/ResetUserPreferences/${key}/${value}`));
    const params = {
        headers: {
            "accept": "application/json",
            "authorization": "bearer " + token
        },
        method: "POST"
    };
    var start = new Date();
    const activityCode = `MBHWeb.Api.Account.ResetUserPreferences.${key}.Put`;
    return fetchWithCreds(fullUrl, params).then(response => {        
        try {
            logAPI(activityCode, start, fullUrl);
            return response.json();
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, fullUrl, E);
            return { isSuccessful: false };
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, fullUrl, err);
        return { isSuccessful: false };
    });
};



/**
* resetUserPreferences2
* 
* @param {string} token  = current user token
* @returns {Promise} ResultStructure
*/
export const resetUserPreferences2 = (token, key, value) => {

    const fullUrl = encodeURI(tools.buildUrl(apiBaseUrl, `/v2/HealthSource/Preferences/${key}?preferenceValue=${value}`));
    const params = {
        headers: {
            "accept": "application/json",
            "authorization": "bearer " + token
        },
        method: "PUT"
    };
    var start = new Date();
    const activityCode = `MBHWeb.Api.Account.ResetUserPreferences2.${key}.Put`;
    return fetch(fullUrl, params).then(response => {
        try {
            logAPI(activityCode, start, fullUrl);
            return response.json();
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, fullUrl, E);
            return { isSuccessful: false };
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, fullUrl, err);
        return { isSuccessful: false };
    });
};



/**
 * getAllUserPreferences
 * 
 * @param {string} token  = current user token
 * @returns {Promise} ResultStructure
 */
export const getAllUserPreferences = (token) => {
    const fullUrl = encodeURI( tools.buildUrl( portalApiBaseUrl, `/account/GetAllUserPreferences`));
    const params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    var start = new Date();
    const activityCode = `MBHWeb.Api.Account.GetAllUserPreferences.Get`;
    return fetchWithCreds(fullUrl, params).then(response => {
        try {
            logAPI(activityCode, start, fullUrl);
            return response.json();
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, fullUrl, E);
            return { isSuccessful: false };
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, fullUrl, err);
        return { isSuccessful: false };
    });
};

/**
 * getAllUserPreferences2
 * 
 * @param {string} token  = current user token
 * @returns {Promise} ResultStructure
 */
export const getAllUserPreferences2 = (token) => {
    //debugger;
    const fullUrl = encodeURI(tools.buildUrl(apiBaseUrl, `/v2/HealthSource/Preferences`));
    const params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    var start = new Date();
    const activityCode = `MBHWeb.Api.Account.GetAllUserPreferences2.Get`;
    return fetch(fullUrl, params).then(response => {
        try {
            logAPI(activityCode, start, fullUrl);
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, fullUrl, E);
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, fullUrl, err);
        return Promise.reject(err);
    });
};


/**
* getUserInsuranceInfo
* 
* @param {string} token  = current user token
* @param {string} patientid   = patientid
* @param {string} patientidtype   = patientidtype
 */


export const getUserInsuranceInfo = (token, patientid) => {
        
    const url = `${apiBaseUrl}v5/epic/GetCoverage?patientid=${patientid}&patientidtype=EPI`;
    const params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    var start = new Date();
    const activityCode = "MBHWeb.Api.HealthSource.getUserInsuranceInfo";
    return fetch(url, params).then(response => {
        try {
            logAPI(activityCode, start, url);
            return response.json();
        }
        catch (E) {
            logAPI(activityCode + ".Failure", start, url, E);
            return E;
        }
    }).catch(err => {
        logAPI(activityCode + ".Failure", start, url, err);
        return err;
    });
};
